import React from "react"
import ZdqConnectorStatus from "../../components/ZdqConnectorStatus"
import { GENERIC_MYSQL } from "../../Constants"

function ZdqGenericMySqlConnectorStatus() {
    return <ZdqConnectorStatus vendor={GENERIC_MYSQL}></ZdqConnectorStatus>
}

export default ZdqGenericMySqlConnectorStatus